import { useEffect } from "react";

const SITE_URL = "https://myazbnb.com";

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

// Lightweight, dependency-free per-page SEO metadata setter.
export function usePageMeta({ title, description, path = "/", noindex = false } = {}) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    if (title) setMeta("property", "og:title", title);
    setCanonical(`${SITE_URL}${path}`);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    return () => {
      // Restore indexable default when leaving a noindex page
      if (noindex) setMeta("name", "robots", "index, follow");
    };
  }, [title, description, path, noindex]);
}
